/* tslint:disable */
/* eslint-disable */
// @ts-nocheck
/**
 * Audius API
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CoinMembersCountResponse
 */
export interface CoinMembersCountResponse {
    /**
     * The total number of users with a non-zero balance of the specific coin
     * @type {number}
     * @memberof CoinMembersCountResponse
     */
    data: number;
}

/**
 * Check if a given object implements the CoinMembersCountResponse interface.
 */
export function instanceOfCoinMembersCountResponse(value: object): value is CoinMembersCountResponse {
    let isInstance = true;
    isInstance = isInstance && "data" in value && value["data"] !== undefined;

    return isInstance;
}

export function CoinMembersCountResponseFromJSON(json: any): CoinMembersCountResponse {
    return CoinMembersCountResponseFromJSONTyped(json, false);
}

export function CoinMembersCountResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): CoinMembersCountResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'data': json['data'],
    };
}

export function CoinMembersCountResponseToJSON(value?: CoinMembersCountResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'data': value.data,
    };
}

